import React, { type FC } from 'react';
import { token } from '@atlaskit/tokens';

import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';

import { borderRadius, gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import {
	JiraSpotlight,
	type JiraSpotlightProps,
} from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';

const DIALOG_WIDTH = 41 * gridSize;

export type DefaultProps = {
	targetBgColor: JiraSpotlightProps['targetBgColor'];
	targetRadius: JiraSpotlightProps['targetRadius'];
	dialogWidth: JiraSpotlightProps['dialogWidth'];
};

const defaultProps = {
	targetBgColor: token('elevation.surface'),
	targetRadius: borderRadius,
	dialogWidth: DIALOG_WIDTH,
};

const spotlightWithDefaults =
	(defaults: DefaultProps): FC<JiraSpotlightProps> =>
	(props: JiraSpotlightProps) => {
		const { children, ...rest } = props;
		return (
			<ShortcutScope>
				<JiraSpotlight {...defaults} {...rest}>
					{children}
				</JiraSpotlight>
			</ShortcutScope>
		);
	};

export const StyledSpotlight = spotlightWithDefaults(defaultProps);
